import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import { InputStyle, TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => {
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    return {
        configurationCompleted: state.pages.productDetails.configurationCompleted,
        variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
        isAuthenticated,
    };
};

export interface ProductDetailsQuantityOrderedStyles {
    quantityOrdered?: TextFieldProps;
    quantityText?: TypographyPresentationProps;
    quantityContainer?: InjectableCss;
}

export const quantityOrderedStyles: ProductDetailsQuantityOrderedStyles = {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-top: 10px;
                ${InputStyle}{
                    &:focus, &:focus-within {
                        border: 2px solid ${getColor("common.border")} !important;
                        border-radius: 6px !important;
                    }
                }
            `,
        },
    },
    quantityText: {
        css: css`
            position: absolute;
            color: ${getColor("text.accent")};
            top: -4px;
            margin-bottom: 0;
            font-weight: 700;
            font-size: 14px;
        `,
    },
    quantityContainer: {
        css: css`
            position: relative;
        `,
    },
};

const styles = quantityOrderedStyles;

const ProductDetailsQuantityOrdered = ({
    configurationCompleted,
    variantSelectionCompleted,
    isAuthenticated,
}: Props) => {
    return (
        <StyledWrapper {...styles.quantityContainer}>
            {isAuthenticated && <StyledWrapper {...styles.quantityText}>QTY</StyledWrapper>}
            <ProductQuantityOrdered
                configurationCompleted={configurationCompleted}
                variantSelectionCompleted={variantSelectionCompleted}
                extendedStyles={styles.quantityOrdered}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuantityOrdered)),
    definition: {
        displayName: "Quantity Ordered",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
